'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This is use to hold the additional information about styles compiled to CSS
 * classes. Only used during test runs.
 */
var CSSClassRepresentation = exports.CSSClassRepresentation = function () {
  function CSSClassRepresentation(className, representation, representationName) {
    _classCallCheck(this, CSSClassRepresentation);

    this.className = className;
    this.representation = representation;
    this.representationName = representationName;
  }

  _createClass(CSSClassRepresentation, [{
    key: 'valueOf',
    value: function valueOf() {
      return this.className;
    }
  }]);

  return CSSClassRepresentation;
}();

/**
 * This is use to hold the additional information about CSS classes
 * concatenation. Only used during test runs.
 */


var CSSClassJoinRepresentation = exports.CSSClassJoinRepresentation = function () {
  function CSSClassJoinRepresentation(styles) {
    _classCallCheck(this, CSSClassJoinRepresentation);

    this.styles = styles;
  }

  _createClass(CSSClassJoinRepresentation, [{
    key: 'valueOf',
    value: function valueOf() {
      return this.styles.join(' ');
    }
  }]);

  return CSSClassJoinRepresentation;
}();
